const LIGHT_BROWN = '#b27444'
const DARK_BROWN = '#784b34'
const TEXT_ICONS_SECONDARY = '#868E96'
const BORDER_SECONDARY = '#ced4da'

export { LIGHT_BROWN, DARK_BROWN, TEXT_ICONS_SECONDARY, BORDER_SECONDARY }
